import React from 'react';
import { Modal } from 'react-bootstrap';
import { BSModal } from '~/components/Bootstrap';
import { ProviderType } from '~/util/providerUtils';
import {
    CareRequestTypeOptionType,
    IcdCodeOptionType,
    ReferralOrgFieldsState,
} from '~/components/Patient/Referrals/ReferralInfo/ReferralInfo';
import { ProviderPrint } from '../ProviderPrint';

export interface ConfirmReferralModalProps {
    show: boolean;
    close: () => void;
    sendReferral: (type: string, confirmSend?: boolean) => void;
    patient: PatientType;
    provider: ProviderType;
    reason: string;
    notes: string;
    patientEmail: string;
    location?: undefined | LocationType;
    orgFormFields?: ReferralOrgFieldsState;
    startDate?: Date | null;
    endDate?: Date | null;
    diagnosisCodes?: IcdCodeOptionType[];
    visitNumber?: number | null;
    careRequestType?: CareRequestTypeOptionType | null;
    fromProviderName?: string;
}
export function ConfirmReferralModal({
    show,
    close,
    sendReferral,
    patient,
    provider,
    reason,
    notes,
    patientEmail,
    location,
    orgFormFields,
    startDate,
    endDate,
    diagnosisCodes = [],
    visitNumber,
    careRequestType,
    fromProviderName,
}: ConfirmReferralModalProps) {
    return (
        <BSModal
            id="confirm-referral"
            show={show}
            onHide={close}
            aria-labelledby="confirm-referral-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="confirm-referral-title" role="heading" aria-level={1}>
                    Confirm Referral Send
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    You suggested an edit to this provider&apos;s information. This referral will be
                    sent to the provider&apos;s currently listed fax number. Do you want to
                    continue?
                </p>
                <p>
                    You can click &quot;Print Referral&quot; to generate a PDF and send it through
                    another method.
                </p>
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
                <div>
                    <ProviderPrint
                        referralStatus="unconfirmed"
                        patient={patient}
                        provider={provider}
                        reason={reason}
                        notes={notes}
                        patientEmail={patientEmail}
                        location={location}
                        btnClass="btn-info"
                        btnText="Print Referral"
                        orgFormFields={orgFormFields}
                        startDate={startDate}
                        endDate={endDate}
                        diagnosisCodes={diagnosisCodes}
                        visitNumber={visitNumber}
                        careRequestType={careRequestType}
                        fromProviderName={fromProviderName}
                    />
                </div>
                <div>
                    <button type="button" className="btn btn-secondary justify-con" onClick={close}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary ms-2"
                        onClick={() => sendReferral('', true)}
                    >
                        Yes, Send
                    </button>
                </div>
            </Modal.Footer>
        </BSModal>
    );
}
